import { Box, Button, CircularProgress, Collapse, Divider, Stack, TextField, Tooltip } from "@mui/material";
import { ClearOutlined, DownloadOutlined } from "@mui/icons-material";
import { RefreshOutlined } from "@material-ui/icons";
import AutocompleteCombobox, { adaptDataValueToAutocompleteData } from "../../shared/AutocompleteCombobox";

export default function MesEquipesFilters({ showFilters, filters, filterOptions, loading, activeFilters,
  changeFilters, resetFilters, refreshList, downloadExcel, isExporting, total }) {
  const services = filterOptions.services.filter((service) => !filters.direction ||
    Number(service.direction_id) === Number(filters.direction.direction_id));
  const handleChangeAutoCompleteDirectionFilter = (direction) => changeFilters({ direction, service: null });
  const handleChangeAutoCompleteServiceFilter = (service) => changeFilters({ service });
  const handlechangeFiltre = (event) => changeFilters({ mot_cle: event.target.value });
  const handleResetFilters = resetFilters;
  const handleRefreshTable = refreshList;
  return (
        <Collapse in={showFilters} timeout="auto" unmountOnExit>
          <Box
            sx={{
              px: 2,
              py: 1.5,
              bgcolor: "#f8fafc",
              borderRadius: 2,
              border: "1px solid #e2e8f0",
            }}
          >
            <Stack
              direction={{ xs: "column", md: "row" }}
              spacing={1.5}
              alignItems={{ xs: "stretch", md: "center" }}
              flexWrap="wrap"
              useFlexGap
            >
              <AutocompleteCombobox
                fullWidth
                stylex={{ minWidth: 140, flex: "1 1 140px" }}
                limitTags={2}
                label="Direction"
                class_name="filtre_list"
                loading={loading}
                data={adaptDataValueToAutocompleteData(
                  filterOptions.directions,
                  "code",
                  "direction_id",
                )}
                valeur={
                  filters.direction?.direction_id ? filters.direction : null
                }
                onChange={handleChangeAutoCompleteDirectionFilter}
              />
              <AutocompleteCombobox
                fullWidth
                stylex={{ minWidth: 160, flex: "1 1 160px" }}
                limitTags={2}
                label="Service"
                class_name="filtre_list"
                loading={loading}
                data={adaptDataValueToAutocompleteData(
                  services,
                  "code",
                  "service_id",
                )}
                valeur={filters.service?.service_id ? filters.service : null}
                onChange={handleChangeAutoCompleteServiceFilter}
              />
              <TextField
                sx={{ minWidth: 220, flex: "1 1 220px" }}
                size="small"
                value={filters.mot_cle}
                name="mot_cle"
                label="Mot clé"
                placeholder="Rechercher..."
                onChange={handlechangeFiltre}
                className="filtre_list"
              />
            </Stack>

            <Divider sx={{ my: 1.5 }} />

            <Stack
              direction="row"
              spacing={1}
              justifyContent="flex-end"
              flexWrap="wrap"
              useFlexGap
            >
              <Tooltip title="Réinitialiser les filtres">
                <span>
                  <Button
                    variant="text"
                    color="inherit"
                    size="small"
                    startIcon={<ClearOutlined />}
                    onClick={handleResetFilters}
                    disabled={activeFilters === 0}
                  >
                    Réinitialiser
                  </Button>
                </span>
              </Tooltip>

              <Tooltip title="Actualiser la liste">
                <Button
                  variant="outlined"
                  size="small"
                  startIcon={<RefreshOutlined />}
                  onClick={handleRefreshTable}
                >
                  Actualiser
                </Button>
              </Tooltip>

              <Button
                variant="contained"
                size="small"
                color="primary"
                onClick={downloadExcel}
                disabled={isExporting || loading || total === 0}
                startIcon={
                  isExporting ? (
                    <CircularProgress size={16} color="inherit" />
                  ) : (
                    <DownloadOutlined />
                  )
                }
                sx={{ textTransform: "none", fontWeight: 600 }}
              >
                {isExporting ? "Export..." : "Excel export"}
              </Button>
            </Stack>
          </Box>
        </Collapse>

  );
}
